import { SOCIALS, CONTACT_EMAIL } from "@/constants/socials";
import { Instagram, Youtube, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const TikTokIcon = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83a8.32 8.32 0 0 0 4.85 1.55v-3.5a4.85 4.85 0 0 1-1.92-.19Z" />
  </svg>
);

const ICONS = {
  instagram: <Instagram size={18} />,
  youtube: <Youtube size={18} />,
  facebook: <Facebook size={18} />,
  tiktok: <TikTokIcon size={18} />,
};

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A0A] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-white text-[#0A0A0A] font-extrabold text-sm tracking-tight">
                O
              </span>
              <span className="font-extrabold tracking-tight text-lg">
                OperatorAI
              </span>
            </div>
            <p className="mt-4 text-sm text-white/60 max-w-md leading-relaxed">
              AI Workflow Leverage for Operators and SMBs. Practical AI
              workflows that save small businesses and operators real time,
              every week.
            </p>

            <div className="mt-6 flex items-center gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.key}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.key}`}
                  aria-label={s.name}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white/5 border border-white/10 hover:bg-[#0052FF] hover:border-[#0052FF] transition-colors"
                >
                  {ICONS[s.key]}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">
              Navigation
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#problem" className="text-white/80 hover:text-white">
                  The Problem
                </a>
              </li>
              <li>
                <a
                  href="#what-we-do"
                  className="text-white/80 hover:text-white"
                >
                  What We Do
                </a>
              </li>
              <li>
                <a href="#guide" className="text-white/80 hover:text-white">
                  Free Guide
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-white">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">
              Legal
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy-link"
                  className="text-white/80 hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms-link"
                  className="text-white/80 hover:text-white"
                >
                  Terms
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid="footer-contact-link"
                  className="text-white/80 hover:text-white"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} OperatorAI — operatoraihq.com. All
            rights reserved.
          </p>
          <p
            data-testid="footer-affiliate-disclosure"
            className="text-xs text-white/40 max-w-xl"
          >
            Some content may contain affiliate links. We only recommend tools
            we believe provide value.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
